// filename: gtmReadyAfterHydration.ts 
// Purpose: Emit a GTM-friendly custom event once React initial render/hydration completes. 
// Why: GTM can listen to custom events and fire tags only after this moment.  

declare global {
    interface Window {
        __reactHydrationEventFired__?: boolean;
    }
}

/**
 * Emits a CustomEvent and a dataLayer.push event that GTM can listen to.
 * Will only fire once per page load.
 */
export function notifyGtmAfterHydration(eventName = 'react_hydrated'): void {
    if (typeof window === 'undefined') return;

    if (window.__reactHydrationEventFired__) return;
    window.__reactHydrationEventFired__ = true;

    // 1) Dispatch a DOM CustomEvent (optional, useful for your own listeners)
    //    Not directly used by GTM, but handy if you want to hook things without dataLayer.
    window.dispatchEvent(new CustomEvent(eventName));

    // 2) Push into GTM dataLayer with "event" key — this is what GTM listens to.
    //    GTM requires "event" exactly; other keys are optional context.
    const payload = {
        event: eventName,
        hydratedAt: Date.now(),
    };

    // Ensure dataLayer exists even if GTM loads later
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push(payload);
}
